import { render, staticRenderFns } from "./table_config_column_batchsetting.vue?vue&type=template&id=6dbc98e1"
import script from "./table_config_column_batchsetting.vue?vue&type=script&lang=js"
export * from "./table_config_column_batchsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbc98e1')) {
      api.createRecord('6dbc98e1', component.options)
    } else {
      api.reload('6dbc98e1', component.options)
    }
    module.hot.accept("./table_config_column_batchsetting.vue?vue&type=template&id=6dbc98e1", function () {
      api.rerender('6dbc98e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/metadata/table_config_column_batchsetting.vue"
export default component.exports